import Vue from "vue";
import Router from "vue-router";
import Home from "../components/Home";
import About from "../components/About";
import Gallery from "../components/Gallery";
import Register from '../components/Register'
import Faq from "../components/Faq";
import Contact from "../components/Contact";
import cTeam from '../components/Team'
import Ipdyi from "../components/programs/ipdyi/Ipdyi";
import iTeam from '../components/programs/ipdyi/Team'
import Department from "../components/programs/ipdyi/Department";
import Thc from "../components/programs/thc/Thc";
import hTeam from '../components/programs/thc/Team'
import Fbs from "../components/programs/bli/bli";
import fTeam from '../components/programs/bli/Team'
import Rpc from "../components/programs/rpc/Rpc";
import rTeam from '../components/programs/rpc/Team'

Vue.use(Router);
let router = new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      component: Home
    },
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/clc-team",
      name: "Team",
      component: cTeam
    },
    {
      path: "/ipdyi",
      name: "IPDYI",
      component: Ipdyi
    },
    {
      path: "/ipdyi-teams",
      name: "iTeams",
      component: iTeam
    },
    {
      path: "/ipdyi-department",
      name: "Department",
      component: Department,
      props:true
    },
    {
      path: "/rhema-prophetic-centre",
      name: "RPC",
      component: Rpc
    },
    {
      path: "/rhema-teams",
      name: "rTeam",
      component: rTeam
    },
    {
      path: "/business-leadership-institute",
      name: "FBC",
      component: Fbs
    },
    {
      path: "/business-team",
      name: "fTeam",
      component: fTeam
    },
    {
      path: "/trauma-healing-centre",
      name: "thc",
      component: Thc
    },
    {
      path: "/healing-team",
      name: "hTeam",
      component: hTeam
    },
    {
      path: "/gallery",
      name: "Gallery",
      component: Gallery
    },
    {
      path: "/about",
      name: "About",
      component: About
    },
    {
      path: "/faq",
      name: "Faq",
      component: Faq
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      props: true
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact
    }
  ]
});

export default router;
